import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { useNavModel } from "../../../../model/navModel";
import { useDataCatalogModel } from "../dataCatalogModel";
import { Form, Button, Table } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { ColumnsType } from "antd/es/table";
import DetailDrawer from "./DetailDrawer"
import {catalogService,fieldService,FieldDetails} from "../dataCatalogService"
import { globalPrompt } from "../../../../components2/YhMessage"
import { DetailType } from "../dataCatalogTypes";
import CatalogForm from "./CatalogForm"

const CataLogDetail = () => {
    const history:any = useHistory();
    const { selectedNavId,addNav, closeNav,getSelectedNavState } = useNavModel()
    const { fieldData,fieldSelectRowKeys,selectedRow,drawerVisible,updataEditParam,removeField, loadField,setDrawerVisible,updataData,setDrawerTitle,setFieldSelectRowKeys,setFieldSelectRow } = useDataCatalogModel()
    const [form] = Form.useForm();
    const [modes,setModes] = useState<any>(getSelectedNavState("state"))
    const {id,pageParams} = modes
    const {mode,id:ids} = pageParams
    useEffect(() => {
        console.log(mode)
        loadField()
    }, [])
    const title = <div className="font-bold font-size-lg">新增数据目录</div>
    const tableAction = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode==DetailType.look}
            onClick={() => addRow()}
        >新增字段</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode==DetailType.look}
            onClick={() => editRow()}
        >编辑字段</Button>        
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode==DetailType.look}
            onClick={() => rmRow()}
        >删除字段</Button>
    </>
    const addRow = ()=>{
        setDrawerTitle(DetailType.add)
        setDrawerVisible(!drawerVisible)
    }
    const editRow = ()=>{
        if(fieldSelectRowKeys.length==0){
            return globalPrompt("message", { type: "error", text: "选择您要编辑的数据" })
        }
        setDrawerTitle(DetailType.edit)
        setDrawerVisible(!drawerVisible)
    }
    const rmRow = ()=>{
        if(fieldSelectRowKeys.length==0){
            return globalPrompt("message", { type: "error", text: "选择您要删除的数据" })
        }
        removeField()
    }
    const columns: ColumnsType<any> = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '字段编码',
            dataIndex: 'code',
            // width: 150,
        },
        {
            title: '数据类型',
            dataIndex: 'dataType',
            // width: 150,
        },
        {
            title: '最大长度',
            dataIndex: 'maxLength',
        },
        {
            title: '可更新',
            dataIndex: 'updatable',
            render: (text) => text?"更新":"不更新"
        },
        {
            title: '是否可为空',
            dataIndex: 'nullable',
            render: (text) => text?"是":"否"
        },
        {
            title: '唯一',
            dataIndex: 'repeatable',
            render: (text) => {
                switch(text){
                    case 1: return "全表唯一";
                    case 2: return "分支唯一";
                    case 0: return "否";
                    default: return
                }
            }
        },
    ]
    const title1 = <div className="font-bold font-size-lg">{mode == DetailType.edit?"编辑字段":"查看字段"}</div>

    const onRow = (record: FieldDetails) => {
        return {
            onClick: () => {
                if (fieldSelectRowKeys.length > 0 && fieldSelectRowKeys[0] === record.key) {
                    setFieldSelectRowKeys([])
                    setFieldSelectRow({})
                } else {
                    setFieldSelectRowKeys([record.key as string])
                    setFieldSelectRow(record)
                }
            },
        }
    }
    const rowSelection = {
        onChange(selectedRowKeys: React.Key[], selectedRows: FieldDetails[]) {
            setFieldSelectRowKeys(selectedRowKeys)
        },
        selectedRowKeys:fieldSelectRowKeys
    }    
    return (
        <>
            <CatalogForm/>
            <YhBox title={title1} action={tableAction}>
                <Table 
                    columns={columns}
                    dataSource={fieldData}
                    scroll={{y:200}}
                    size="small"
                    rowSelection={{
                        type: "radio",
                        ...rowSelection
                    }}
                    onRow={onRow}
                    pagination={false}
                ></Table>
            </YhBox>
            <DetailDrawer/>
        </>
    )
}
export default CataLogDetail